import React, { Component } from "react";
import "./Splash.css";
class Splash extends Component {
  render() {
    return (
      <div className="container-splash" style={{ zIndex: 9999999 }}>
        <div id="logoWrp" style={{ zIndex: 9999999 }} className="animate">
          <svg id="logo" style={{ zIndex: 9999999 }} viewBox="0 0 564 564">
            <defs>
              <circle id="a" cx="267.85" cy="267.85" r="267.85" />
            </defs>
            <g transform="translate(14 14)" fill="none" fillRule="evenodd">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <use
                stroke="#979797"
                strokeWidth="1.1"
                fill="#D8D8D8"
                xlinkHref="#a"
              />
              <path fill="#99ffcc" mask="url(#b)" d="M0 0h535.7v535.7H0z" />
              <path
                className="grey"
                d="M212.8,120.9v4.3l-9.5,1.3c-4.9,1-9,3.3-10.9,8.2a20,20,0,0,0-1.2,5.9c-.2,9.9-.2,19.7-.3,29.6,0,4.6,0,9.3.1,13.9a1.8,1.8,0,0,1-1.3,1.9,196.5,196.5,0,0,1-39,11.6,209.6,209.6,0,0,1-43.3,3.2c-12.6-.4-25.1-2.1-37-6.7a93.4,93.4,0,0,1-18.2-9c-3.9-2.6-7.8-5.2-11.4-8.1s-7.7-7.2-11.5-10.9-7.7-9.9-10.8-15.3c-6.1-10.4-8.8-21.8-9.8-33.6-1.3-16.5.7-32.6,7.6-47.8A82.4,82.4,0,0,1,28,50.4,120.7,120.7,0,0,1,38.9,38.7,92.8,92.8,0,0,1,61.4,23,103.3,103.3,0,0,1,95.3,12.7a141.8,141.8,0,0,1,33.2-.1,89.9,89.9,0,0,1,21.8,5.1c6.3,2.3,12.7,4.5,19.1,6.6s9.4,0,12.4-4.5a42.5,42.5,0,0,0,2.7-5.2c.5-.8.8-1.7,1.3-2.5a1.4,1.4,0,0,1,.9-.3h4.1V75.5a19.7,19.7,0,0,1-4.2-.1c-1.3-.2-1.5-1.7-2-2.8-1.7-3.9-3.3-7.8-5.2-11.7a38,38,0,0,0-4-6.8c-3.8-4.8-7.5-9.7-11.9-13.8a63.7,63.7,0,0,0-21.7-13.6A65.9,65.9,0,0,0,108,23.1a50.1,50.1,0,0,0-22.8,9.2A62.7,62.7,0,0,0,74.8,42.5c-6.3,7.8-9.3,17-12,26.4a121.7,121.7,0,0,0-4.4,25.4c-.5,7.4-.5,14.8-.3,22.2a115.1,115.1,0,0,0,3.6,27.4c2.3,8.8,4.8,17.7,10.2,25.2,3.3,4.6,7,8.9,11.8,12a58.5,58.5,0,0,0,25.7,9.2,74.6,74.6,0,0,0,30.4-2.9l5.4-1.7a1.1,1.1,0,0,0,1-1.3c0-13.9,0-27.7-.1-41.5a49,49,0,0,0-.8-7.7c-.6-2.7-2.5-4.6-4.8-6.1-4.9-3.2-10.3-4-16-3.8h-2.1v-4.3Zm114,182.6-1.3-.2c-5.8-.8-10.8-3-14.1-8.1s-4.8-7.3-6.9-11.2c-2.9-5.6-5.5-11.3-8.2-17.1-3.7-8.2-7.4-16.5-11.2-24.8L274,217.5l-12-26.6-10.3-22.8-11.6-25.7c-2.7-6.1-5.4-12.2-8-18.3a1.7,1.7,0,0,0-1.9-1.2c-1,0-1.7.1-2.2,1.2-3.2,7.2-6.6,14.4-9.9,21.6s-7.9,17.3-11.9,25.9-7,15.1-10.4,22.7-7.7,16.6-11.5,24.8-7.2,15.8-10.9,23.6-7.9,17.2-11.8,25.9-7.5,16.4-12.9,23.7a26.4,26.4,0,0,1-13.1,9.7,51.5,51.5,0,0,1-5.6,1.6V308h61.6v-4.5l-2.7-.2c-4.1-.6-8.1-1-12.1-1.9-6.1-1.4-9.2-5.4-9.6-11.7a25.7,25.7,0,0,1,1.8-10.3c2-5.1,4.4-10.1,6.6-15.1,1-2.2,2-4.4,2.9-6.6s.9-1.4,1.9-1.3a28.1,28.1,0,0,0,2.9,0h59.6c.9,0,1.6,0,2,1.1,3,6.7,6.1,13.4,9,20.2a111.4,111.4,0,0,1,5.1,13.6c1.5,5.6-.8,9.3-6.1,10.8a35.3,35.3,0,0,1-6.5,1.1c-2.9.3-5.9.3-8.9.5V308h89.9v-4.4ZM183.7,246.4l28.5-62.2,1.9,4.3c1.3,2.9,2.4,5.7,3.7,8.5,3.8,8.7,7.7,17.4,11.6,26.1l9.9,22.2.4,1.1Z"
                transform="translate(35,50) scale(1.3)"
                fill="#231F20"
              />
              <circle
                stroke="#231F20"
                strokeWidth="14"
                cx="267.85"
                cy="267.85"
                r="274.85"
              />
            </g>
          </svg>
        </div>
      </div>
    );
  }
}

export default Splash;
